import { Theme } from '@mui/material';

export const MuiFormHelperTextStyled = (theme: Theme) => {
    theme.components = {
        ...theme.components,
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        fontSize: '0.875rem',
                        fontWeight: 600,
                    },
                },
            },
        },
    };
};
